import { useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import {
  LEADS_PATH,
  SALES_FUNNELS_LEADS_PATH,
  SALES_FUNNELS_LEAD_CARD_PATH,
} from '@app/constants';

interface HistoryStateWithIndex {
  idx?: number;
}

interface UseLeadCardPageBackNavigationResult {
  goBack(): void;
}

const getHistoryIndex = (): number => {
  const state = window.history.state as HistoryStateWithIndex | null;

  return typeof state?.idx === 'number' ? state.idx : 0;
};

export const useLeadCardPageBackNavigation =
  (): UseLeadCardPageBackNavigationResult => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const isFunnelSource =
      searchParams.get('source') === 'funnels' ||
      location.pathname === SALES_FUNNELS_LEAD_CARD_PATH;

    const goBack = useCallback(() => {
      if (getHistoryIndex() > 0) {
        navigate(-1);
        return;
      }

      navigate(isFunnelSource ? SALES_FUNNELS_LEADS_PATH : LEADS_PATH);
    }, [isFunnelSource, navigate]);

    return { goBack };
  };
